'use strict';
var tripTypeUtils = require('../../modules/utils/trip_type');

Odigeo.defineWidget('flexible_dates', Odigeo.Widget.extend(Odigeo._.extend({
    viewClass: require('./view'),
    modelClass: require('./model'),

    searchFlexibleDates: function() {
        this.model.setUpData();
        var tripType = this.model.get('tripType');
        if (tripTypeUtils.isOneWayOrRoundTrip(tripType) && this.model.get('isNewSearch')) {
            this.model.refresh();
        }
        this.model.unset('isNewSearch');
    },

    getFlexibleDates: function(data) {
        if (Odigeo._.get(data, 'isNewSearch', false)) {
            this.view.cleanView();
            this.model.cleanData();
        }
        if (data) {
            this.getFlexibleDatesInfo(data);
        }
    },

    getFlexibleDatesInfo: function(data) {
        var tripType = tripTypeUtils.fromResults(data.tripType);
        this.model.set('tripType', tripType);
        this.model.set('isNewSearch', data.isNewSearch);
        this.model.set('actualPrice',
            (_(data.flexibleDatesInfo).filter(function(result) {
                return result.main;
            }).first() || {}).price);
        if (this.hasToSearchFlexibleDatesOneWay(tripType) || this.hasToSearchFlexibleDatesRoundTrip(tripType)) {
            this.searchFlexibleDates();
        }
    },

    hasToSearchInResultsOneWay: function() {
        return this.isFlexibleDatesScope() && this.options.page === 'results';
    },

    hasToSearchFlexibleDatesOneWay: function(tripType) {
        return this.hasToSearchInResultsOneWay() && tripTypeUtils.isOneWay(tripType);
    },

    isFlexibleDatesScope() {
        return !Odigeo.Utils.isRequestApp('dp') && Odigeo.SessionScope.flow === 'mobile';
    },

    hasToSearchFlexibleDatesRoundTrip(tripType) {
        return this.isFlexibleDatesScope() && tripTypeUtils.isRoundTrip(tripType);
    },

    init: function() {
        this.options.savingsThresholdLow = parseInt(this.options.savingsThresholdLow, 10);
        this.options.savingsThresholdHigh = parseInt(this.options.savingsThresholdHigh, 10);
    },
    toggleFlexibleDates(isFirstBatch) {
        this.view.toggleFlexibleDates(isFirstBatch);
    },
})));

